import PublicErrorPage from "./PublicErrorPage";

export default PublicErrorPage;
